/**
 * Dropdown
 */
export default class Dropdown {
  constructor(dropdown) {
    this.button = dropdown;
    this.container = dropdown.parentNode;
    this.activeClass = this.button.getAttribute('dropdown-active-class')
      ? this.button.getAttribute('dropdown-active-class')
      : 'is-active';
    this.isOpened = false;
    this.clickOutSide = true;
    this.documentClick = this.documentClick.bind(this);
    this.button.dropdown = this;
    this.container.dropdown = this;
  }

  /**
   * Init
   */
  init() {
    if (this.button.classList.contains('plugin-dropdown-initialized')) return;

    if (this.button.getAttribute('dropdown-target')) {
      this.container = document.querySelector(this.button.getAttribute('dropdown-target'));
      this.container.dropdown = this;
    }

    if (this.button.getAttribute('dropdown-click-outside') === 'false') {
      this.clickOutSide = false;
    }

    if (this.button.getAttribute('dropdown-overlay')) {
      this.overlay = document.querySelector(this.button.getAttribute('dropdown-overlay'));
    }

    const closeButtons = Array.from(this.container.querySelectorAll('[dropdown-close]'));
    if (closeButtons.length > 0) {
      closeButtons.forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
          if (closeButton.getAttribute('dropdown-close')) {
            const closeButtonTarget = document.querySelector(
              closeButton.getAttribute('dropdown-close'),
            );

            if (closeButtonTarget && closeButtonTarget.dropdown) {
              closeButtonTarget.dropdown.close();
            }
          } else {
            this.close();
          }
        });
      });
    }

    this.button.addEventListener('click', (event) => this.toggle(event));

    this.button.classList.add('plugin-dropdown-initialized');
  }

  /**
   * Toggle
   * @param {*} event event
   */
  toggle(event) {
    event.preventDefault();
    if (this.isOpened) {
      this.close();
    } else {
      this.open();
    }
  }

  /**
   * Document Click Func
   * @param {*} event event
   */
  documentClick(event) {
    const clickInside = this.container.contains(event.target);
    if (this.isOpened && !clickInside) {
      this.close();
    }
  }

  /**
   * Open
   */
  open() {
    if (this.overlay) {
      this.overlay.classList.add(this.activeClass);
    }
    this.container.classList.add(this.activeClass);
    this.button.classList.add(this.activeClass);

    if (this.clickOutSide) {
      setTimeout(() => {
        document.addEventListener('click', this.documentClick);
      }, 400);
    }
    this.isOpened = true;
  }

  /**
   * Close
   */
  close() {
    if (this.overlay) {
      this.overlay.classList.remove(this.activeClass);
    }
    this.container.classList.remove(this.activeClass);
    this.button.classList.remove(this.activeClass);
    if (this.clickOutSide) {
      document.removeEventListener('click', this.documentClick);
    }
    this.isOpened = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = Array.from(document.querySelectorAll('.js-dropdown'));
  dropdowns.forEach((button) => {
    const dropdown = new Dropdown(button);
    dropdown.init();
  });
});
